import { Component, ElementRef, HostBinding, OnInit, ViewChild, OnDestroy, Inject } from '@angular/core';
import { Task } from '../../../models/task';
import { UserstoryService } from '../../../services/userstory.service';
import { SettingsService } from '../../../services/settings.service';
import { SynchronizationService } from '../../../services/synchronization.service';
import { Status } from '../../../models/status';
import { Userstory } from '../../../models/userstory';
import { PopupDodComponent } from '../../popup-dod/popup-dod.component';
import SelectableComponent from '../../../interfaces/selectableComponent';
import { AwallComponentEvent } from '../../../models/awallComponentEvent';
import { HighlightTeammemberService } from '../../../services/highlight-teammember.service';
import { IssuecardComponent } from '../../issuecard/issuecard.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { KanbanBacklogComponent } from '../backlog/backlog.component';
import { definitionOfDoneDisplayType } from '../../../models/enums/dodDisplayType';
import { Issue } from '../../../models/issue';
import { EventIssuecardUpdated } from '../../../models/syncEvents/realtimeEvents/eventIssuecardUpdated';
import { EventIssueDeleted } from '../../../models/syncEvents/persistenceEvents/eventIssueDeleted';
import { KanbanBoardViewComponent } from '../../../actionviews/kanban-board-view/kanban-board-view.component';
import { Listener, CommunicationService } from '../../../services/communication.service';
import { ProjectService } from '../../../services/project.service';
import {OnlineuserService} from '../../../services/onlineuser.service';


/**
 * This is a variant of IssueCardcomponent. Using the template and style of IssueCardComponent.
 * This probably needs to refactored to work properly.
 */

@Component({
  selector: 'app-taskcard-detail',
  templateUrl: '../../issuecard/issuecard.component.html',
  styleUrls: ['../../issuecard/issuecard.component.scss']
  })
export class TaskcardDetailComponent extends IssuecardComponent implements OnInit, OnDestroy, SelectableComponent,
  Listener<AwallComponentEvent>  {

  public kanbanBoardView: KanbanBoardViewComponent;
  // For new issues that are being created and dont have an id and corresponding jira-issue yet
  /**
   * Properties for definition of done
   * Child is only set if dodVersion is issuecard
   */
  @ViewChild(PopupDodComponent) popupDodComponent: PopupDodComponent;
  public dodActive = false;
  public dodType: definitionOfDoneDisplayType;
  focusStyle = '';

  @HostBinding('style.z-index')
  zIndex = 25;

  constructor(
    @Inject('issue') public issueParameter: Issue,
    @Inject('projectKey') public readonly projectKey: string,
    @Inject('statuses') public readonly statuses: Status[],
    @Inject('onCloseCallback') public readonly onCloseCallback,
    @Inject('onNewIssueCreatedCallback') public readonly onNewIssueCreatedCallback,
    @Inject('onNewSUbIssueCreatedCallback') public readonly onNewSubIssueCreatedCallback,
    @Inject('onIssueRemovedCallback') public readonly onIssueRemovedCallback,
    @Inject('onSubIssueRemovedCallback') public readonly onSubIssueRemovedCallback,
    @Inject('onIssueModified') public readonly onIssueModified,
    protected userstoryService: UserstoryService,
    protected settingsService: SettingsService,
    protected projectService: ProjectService,
    protected communicationService: CommunicationService,
    protected syncService: SynchronizationService,
    protected elementRef: ElementRef,
    protected highlightService: HighlightTeammemberService,
    protected translate: TranslateService,
    protected dialog: MatDialog,
    protected onlineUserService: OnlineuserService) {

    super(
      issueParameter, projectKey, statuses, onCloseCallback, onNewIssueCreatedCallback, onNewSubIssueCreatedCallback,
      onIssueRemovedCallback, onSubIssueRemovedCallback, onIssueModified, userstoryService, projectService,
      settingsService, communicationService, syncService, elementRef, highlightService, translate, dialog, onlineUserService,'');

    // Update last viewed timestamp when task card is opened
    this.userstoryService.setLastViewed(projectKey, issueParameter.id).subscribe();
    issueParameter.lastViewedInAwall = new Date().toISOString();
  }

  static getContainer(): HTMLElement {
    return document.getElementById('issuecardContainer');
  }

  ngOnInit(): void {
    this.projectService.getProjectByKey(this.settingsService.getProjectName()).subscribe(project => {
      if (project) {
        this.dodActive = project['definition_of_done_active'];
        this.dodType = project['definition_of_done_version'];
      }
    });
  }

  /** Used for the Status-Select-Element. Allows us to use the status-object directly as value of the select. */
  compareStatus(s1: Status, s2: Status): boolean {
    let match = false;

    s1['statuses'].forEach(status => {
      if (status.id === s2.id) { match = true; }
    });

    return match;
  }

  deleteThisIssue() {
    const projectKey = this.settingsService.getProjectName();
    this.userstoryService.deleteIssue(this.issue.id, projectKey).subscribe((_) => {
      this.syncService.sendPersistenceEventNew(new EventIssueDeleted(this.issue.id, this.issue.isSubissue));
      this.closeThisCard();
      // Remove the issue from the taskboard's datamodel
      if (this.issue.isSubissue) {
        this.kanbanBoardView.getTask(this.issue.id, true);
      } else {
        this.kanbanBoardView.removeUserstoryFromDataModel(this.issue.id);
      }
    });
    this.communicationService.sendData(KanbanBacklogComponent.componentId, { name: 'update-backlog', value: '' });
  }

  saveChanges() {
    if (this.issueHasBeenChanged) {
      this.issueHasBeenChanged = false;
      const projectName = this.settingsService.getProjectName();

      if (this._issue instanceof Task) {
        this.userstoryService.updateTask(projectName, <Task>this.issue);
      }
      if (this._issue instanceof Userstory) {
        this.userstoryService.updateIssue(projectName, this.issue.id, <Userstory>this.issue);
      }
      this.kanbanBoardView.prepareDataForBoard();
    }
  }

  issueStatusChanged(status: Status) {
    this.issueHasBeenChanged = true;
    this.issue.status = status['statuses'][0];
    this.syncService.sendRealTimeEventNew(new EventIssuecardUpdated(this.issue.id, this.issue, this.onlineUserService.getAvatarUrl()));
  }

  confirmNewIssueCreation() {
    // Issue creation is handled by backlog component for kanban
  }

  /**
   * Init a new popup for dod
   */
  onClickDoD() {
    this.kanbanBoardView.onIssueSetToDone(this._issue);
  }
}
